import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const sortButtonStyles = makeStyles(() => ({
    sortButton : {
      
        '& span': {
            display: 'flex',

            '& svg': {
                fill: tcsmColors.blue,
            },
        },
        '&.active': {
            '& svg': {
                transform: 'rotate(180deg)',
            },
        },
    },

}));

